import React, { ReactNode, useMemo } from 'react';
import { CssBaseline } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { getHomepageRuntimeConfig } from '../sitePublishing/publicConfigSource';
import { useOptionalTenant } from '../tenancy/TenantContext';
import { createTenantTheme, isTenantBrandedPath } from './tenantTheme';

export const TenantThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const tenant = useOptionalTenant();
  const location = useLocation();
  const branded = isTenantBrandedPath(location.pathname);
  const configQuery = useQuery({
    queryKey: ['homepageRuntimeConfig', tenant?.tenantId],
    queryFn: () => getHomepageRuntimeConfig(tenant!.tenantId),
    enabled: branded && Boolean(tenant),
  });
  const theme = useMemo(
    () => createTenantTheme(branded ? configQuery.data?.publicSiteRuntime.theme : undefined),
    [branded, configQuery.data?.publicSiteRuntime.theme]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};
